class LongHandQuantityFormatService {
    //For the long hand quantity format should leave as is.
    formatQuantityAccordingToFormat = (quatity) => {
        return quatity;
    };
}

export default LongHandQuantityFormatService;
